module.exports = __webpack_public_path__ + "img/icon_wait_black.e273f7ca.svg";